import tw, { styled } from 'twin.macro';

const NarrowContainer = styled.div`
  ${tw`max-w-4xl px-4 mx-auto pb-10 print:max-w-none`}
`;

export default NarrowContainer;
